import { useGetRitualsQuery } from 'data/__generated__';

import { DataTable } from 'components/DataTable';
import { Loader } from 'components/Loader';

import { ritualsColumns, type RitualRow } from '../constants/ritualsColumns';

export const RitualsList = () => {
    const {
        loading: ritualsLoading,
        data: ritualsData,
        error: ritualsError,
    } = useGetRitualsQuery({ fetchPolicy: 'cache-and-network' });

    if (ritualsLoading && !ritualsData) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (ritualsError || !ritualsData) {
        throw new Error('Une erreur est survenue lors de la récupération des rituels');
    }

    const { rituals } = ritualsData;

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<RitualRow>
                columns={ritualsColumns}
                data={rituals}
                filterMode="client"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/ritual/${row._id}`}
                searchPlaceholder="Nom du rituel"
                searchFilterKey="searchValue"
            />
        </div>
    );
};
